import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Eye, BookOpen, Brain, Zap, Infinity as InfinityIcon, Atom, HeartHandshake, Flame, Compass } from 'lucide-react';
const chapters = [{
  icon: <Eye className="w-6 h-6" data-id="element-1" />,
  text: 'El descubrimiento del DMT — qué es, dónde vive dentro de ti, y por qué su existencia cambia todo sobre cómo entiendes la conciencia.'
}, {
  icon: <Brain className="w-6 h-6" data-id="element-2" />,
  text: 'La glándula pineal, el tercer ojo, y la ciencia detrás de la estructura más misteriosa del cerebro humano — ese pequeño cristal de luz que reposa en tu centro.'
}, {
  icon: <Flame className="w-6 h-6" data-id="element-3" />,
  text: 'La tradición chamánica de la Ayahuasca — la tecnología ancestral que la humanidad ha usado durante milenios para cruzar el umbral, explicada desde adentro y desde afuera.'
}, {
  icon: <BookOpen className="w-6 h-6" data-id="element-4" />,
  text: 'Un relato en primera persona del viaje molecular — escrito con tanta precisión que lo sentirás en el pecho aunque nunca hayas tenido la experiencia.'
}, {
  icon: <Zap className="w-6 h-6" data-id="element-5" />,
  text: 'Qué ocurre cuando el ego colapsa y algo más grande hace contacto. Cómo se siente. Qué muestra. Y por qué tantos que regresan dicen lo mismo: no estaba soñando. Estaba despertando.'
}, {
  icon: <InfinityIcon className="w-6 h-6" data-id="element-6" />,
  text: 'La muerte simbólica del yo, la arquitectura del renacimiento, y lo que el Bardo Thodol tibetano, los Evangelios gnósticos y la física cuántica describen con distintas palabras pero apuntan al mismo punto.'
}, {
  icon: <Atom className="w-6 h-6" data-id="element-7" />,
  text: 'La ciencia que secretamente coincide con los místicos — física cuántica, teoría del campo unificado, resonancia mórfica — presentada de forma que cualquier persona puede sentir, no solo entender.'
}, {
  icon: <HeartHandshake className="w-6 h-6" data-id="element-8" />,
  text: 'El trabajo real de la integración — cómo traer lo infinito de vuelta a la vida ordinaria sin perderlo en el camino.'
}, {
  icon: <Sparkles className="w-6 h-6" data-id="element-9" />,
  text: 'La espiritualidad despojada de todo dogma — la experiencia directa que cada religión del mundo ha intentado describir con palabras insuficientes.'
}, {
  icon: <Compass className="w-6 h-6" data-id="element-10" />,
  text: 'Y el argumento evolutivo final: por qué el DMT puede ser la brújula biológica de la humanidad hacia un despertar que ya está comenzando.'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    x: -20
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export const ChapterList = () => {
  return <section className="w-full max-w-4xl mx-auto px-6 py-16" data-id="element-11">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-16" data-id="element-12">
        <h2 className="text-3xl md:text-4xl font-serif text-amber-400 mb-6" data-id="element-13">
          DMT: La Molécula de Dios es un viaje de 10 capítulos a través del
          territorio más profundo que una mente humana puede explorar.
        </h2>
        <p className="text-xl text-gray-300 font-body max-w-2xl mx-auto" data-id="element-14">
          Escrito en prosa literaria que se lee como una experiencia, no como
          una conferencia. Estructurado con integridad científica. Vivo con
          testimonio personal.
        </p>
        <p className="text-2xl font-serif text-amber-200 mt-8 italic" data-id="element-15">
          En estas páginas encontrarás:
        </p>
      </motion.div>

      <motion.ul variants={container} initial="hidden" whileInView="show" viewport={{
      once: true,
      margin: '-50px'
    }} className="space-y-8 md:space-y-10" data-id="element-16">
        {chapters.map((chapter, index) => <motion.li key={index} variants={item} className="flex items-start gap-6 group" data-id="element-17">
            <div className="flex-shrink-0 mt-1 w-12 h-12 rounded-full bg-cosmic-800 border border-amber-500/30 flex items-center justify-center text-amber-400 group-hover:bg-amber-500/10 group-hover:border-amber-400 transition-colors duration-300 shadow-[0_0_10px_rgba(245,197,66,0.1)]" data-id="element-18">
              {chapter.icon}
            </div>
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed font-body pt-2" data-id="element-19">
              {chapter.text}
            </p>
          </motion.li>)}
      </motion.ul>
    </section>;
};